document.addEventListener('DOMContentLoaded', function () {
  let debounceTimer;

  document.addEventListener('input', function (event) {
    const input = event.target;

    if (!input.matches('#search_main')) return;

    const form = input.closest('form');
    const container = form ? form.querySelector('#livesearch') : null;

    if (!container) return;

    clearTimeout(debounceTimer);

    const query = input.value.trim();

    if (query.length < 2) {
      container.innerHTML = '';
      container.style.setProperty('display', 'none', 'important');
      return;
    }

    debounceTimer = setTimeout(function () {
      const url =
        '/search/suggest?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product,collection,query' +
        '&resources[limit]=5' +
        '&section_id=livesearch';

      fetch(url)
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Predictive search error');
          }

          return response.text();
        })
        .then(function (html) {
          const parser = new DOMParser();
          const responseDocument = parser.parseFromString(html, 'text/html');
          const section = responseDocument.querySelector(
            '#shopify-section-livesearch'
          );

          if (section && section.innerHTML.trim() !== '') {
            container.innerHTML = section.innerHTML;
            container.style.setProperty('display', 'block', 'important');
          } else {
            container.innerHTML = '';
            container.style.setProperty('display', 'none', 'important');
          }
        })
        .catch(function () {
          container.innerHTML = '';
          container.style.setProperty('display', 'none', 'important');
        });
    }, 300);
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('#livesearch').forEach(function (container) {
      const form = container.closest('form');

      if (form && !form.contains(event.target)) {
        container.innerHTML = '';
        container.style.setProperty('display', 'none', 'important');
      }
    });
  });
});